import React from 'react';
import MDSpinner from "react-md-spinner";
import { PromoType } from '../types/entities';
import { PictureWithSources } from './common/PictureWithSources';
import styled from 'styled-components';

const Picture = styled(PictureWithSources)`
  & > img {
    display: block;
    height: auto;
    max-width: 100%;
  }
`;

interface Props {
  selectedPromo: PromoType | null
}

class PromosPageSidebar extends React.Component<Props> {
  render() {
    let promo = this.props.selectedPromo;

    if (!promo) {
      return <div className="p-5 text-center"><MDSpinner singleColor="var(--primary)"/></div>;
    }

    return (
        <>
          <div className="p-5 fade-in" key={promo.id}>
            <h2 className="mb-3">{promo.title}</h2>
            {promo.subtitle && <h4 className="my-3">{promo.subtitle}</h4>}
            {promo.content && <p dangerouslySetInnerHTML={{__html: promo.content}} />}
            {!!promo.images && !!promo.images.image_web && (
              <p>
                {promo.url
                ? <a href={promo.url}><PromoImage promo={promo} /></a>
                : <PromoImage promo={promo} />}
              </p>
            )}
          </div>
        </>
    );
  }

  shouldComponentUpdate(nextProps: Props) {
    return (!!this.props.selectedPromo && !nextProps.selectedPromo)
        || (!this.props.selectedPromo && !!nextProps.selectedPromo)
        || (!!this.props.selectedPromo && !!nextProps.selectedPromo && this.props.selectedPromo.id !== nextProps.selectedPromo.id);
  }
}

const PromoImage = ({ promo }: { promo: PromoType }) => {
  return <Picture
    images={promo.images && promo.images.image_web ? promo.images.image_web : undefined}
    fallback={promo.image_web_v2}
    title={promo.title}
  />;
};

export default PromosPageSidebar;